import { Checkbox, Radio } from "antd";
import React, { useEffect, useState } from "react";
import UploadImage from "../../shared/UploadImage";
import documents from "../../../assets/img/upload/scan.svg";
import idcard from "../../../assets/img/upload/user-octagon.png";
import Input from "../../shared/Input";
import { useForm } from "react-hook-form";
import Button from "../../shared/Button";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import { toast } from "react-hot-toast";
import BeatLoader from "react-spinners/BeatLoader";
import { useParams } from "react-router-dom";
const CreateStep11 = ({ prevStep, nextStep }) => {
  const {
    updatePlaceDetail,
    updatePlace,
    createInfoData,
    finishPlace,
    loading,
    setloading
  } = useCreatePlace();

  const masir = [
    {
      id: 1,
      label: "مالک اقامتگاه ",
      value: "owner"
    },
    {
      id: 2,
      label: "مستاجر بلند مدت",
      value: "tenant"
    },
    {
      id: 1,
      label: "نگهبان / سرایدار",
      value: "janitor"
    },
    {
      id: 1,
      label: "دفتر رزرواسیون",
      value: "reservation"
    }
  ];
  const { id } = useParams();

  const [nesbat, setnesbat] = useState(
    createInfoData.stepSixteen.ownership_type
  );
  const [document_image, setdocument_image] = useState(
    createInfoData.stepSixteen.document_image
  );
  const [owner_certificate, setowner_certificate] = useState(
    createInfoData.stepSixteen.owner_certificate
  );
  const [completeresidences, setcompleteresidences] = useState(false);
  const [completEditeresidences, setcompleteEditeresidences] = useState(false);
  const onChangeNesbat = e => {
    setnesbat(e.target.value);
  };
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm({
    defaultValues:{
      emergency_name:createInfoData.stepSixteen.emergency_name,
      emergency_phone:createInfoData.stepSixteen.emergency_phone
    }
  });
  const onSubmit = data => {
    setloading(true);

    if (document_image === null) {
      toast.error(" آپلود عکس سند یا قبض اجباری است.");
    } else {
      if(id){
        updatePlaceDetail("stepSixteen", {
          ownership_type: nesbat,
          document_image: document_image,
          owner_certificate: owner_certificate,
          emergency_user_name: data.emergency_user_name,
          emergency_number: data.emergency_number
        });
        setcompleteEditeresidences(true);
      }else{
        updatePlaceDetail("stepSixteen", {
          ownership_type: nesbat,
          document_image: document_image,
          owner_certificate: owner_certificate,
          emergency_user_name: data.emergency_user_name,
          emergency_number: data.emergency_number
        });
        setcompleteresidences(true);
       // updatePlace()
      }
    
    }
  };
  useEffect(
    () => {
      setnesbat(createInfoData.stepSixteen.ownership_type);
      setdocument_image(createInfoData.stepSixteen.document_image);
      setowner_certificate(createInfoData.stepSixteen.owner_certificate);
      reset({
        emergency_user_name:createInfoData.stepSixteen.emergency_user_name ?createInfoData.stepSixteen.emergency_user_name :"",
        emergency_number:createInfoData.stepSixteen.emergency_number?createInfoData.stepSixteen.emergency_number:""
      })
    },
    [createInfoData]
  );
console.log("createInfoData",createInfoData)
  useEffect(
    () => {
      if (completeresidences) {
        finishPlace();
      }
    },
    [completeresidences]
  );
  useEffect(
    () => {
      if (completEditeresidences) {
        updatePlace();
      }
    },
    [completEditeresidences]
  );

  return (
    <div>
      <div className="createsteps-choosingbox mt-[50px]">
        <h6 className="mb-[8px] text-[#292D32] text-[18px] font-[700]">
          مالکیت شما نسبت به اقامتگاه :
        </h6>

        <Radio.Group
          defaultValue={createInfoData.stepTwo.type}
          onChange={onChangeNesbat}
          value={nesbat}
        >
          <div className="grid md:grid-cols-4 grid-cols-2 md:gap-[32px] gap-[16px]">
            {masir.map(i =>
              <div
                key={i.value}
                className={`createsteps--radiogroupbox  ${nesbat === i.value
                  ? "createsteps--radiogroupbox--active"
                  : ""}`}
              >
                <Radio value={i.value}>
                  <h5 className=" whitespace-nowrap">
                    {i.label}
                  </h5>
                </Radio>
              </div>
            )}
          </div>
        </Radio.Group>
      </div>
      <div className="grid md:grid-cols-2 grid-cols-1 gap-[20px] my-[50px]">
        <UploadImage
          className="CreateStep11--upload"
          text=" آپلود عکس سند یا قبض"
          uploadImg={documents}
          id="1"
          file={document_image}
          setfile={setdocument_image}
        />
        <UploadImage
          className="CreateStep11--upload"
          text="پروانه کسب"
          uploadImg={idcard}
          orange
          id="2"
          file={owner_certificate}
          setfile={setowner_certificate}
        />
      </div>
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
        شماره ی اضطراری
      </h4>
      <p className="mt-[8px] mb-[32px] text-[18px]">
        مشخصات و شماره تماس یکی از نزدیکان قابل اعتتماد خود را برای موارد خاص و
        فوریتی وارد کنید .{" "}
      </p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="createsteps--grid3 mt-[50px]">
          <Input
            name="emergency_name"
            control={control}
            errors={errors}
            placeholder=" مثال سجاد لطیفی"
            label="نام و نام خانوادگی"
            className="seconadary-input"
          />
          <Input
            name="emergency_phone"
            control={control}
            errors={errors}
            placeholder="+۹۸ ۹۱۲ *** ****"
            label="شماره تماس"
            className="seconadary-input"
          />
        </div>
        <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
          <Button
            varient="gray"
            onClick={() => {
              prevStep();
            }}
          >
            مرحله قبلی
          </Button>

          {id
            ? <Button varient="primary" type='submit'>
                {loading
                  ? <BeatLoader
                      color="#36d7b7"
                      size={10}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  : "  بروزرسانی اقامتگاه اقامتگاه"}
              </Button>
            : <Button varient="primary" type="submit">
                {loading
                  ? <BeatLoader
                      color="#36d7b7"
                      size={10}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  : "  ثبت اقامتگاه"}{" "}
              </Button>}
        </div>
      </form>
    </div>
  );
};

export default CreateStep11;
